import { render, staticRenderFns } from "./TokenDebug.vue?vue&type=template&id=2f8ae700&scoped=true"
import script from "./TokenDebug.vue?vue&type=script&lang=js"
export * from "./TokenDebug.vue?vue&type=script&lang=js"
import style0 from "./TokenDebug.vue?vue&type=style&index=0&id=2f8ae700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ae700",
  null
  
)

export default component.exports